import type { ModuleCatalogEntry, ModuleId } from "./module-catalog.types.ts";

export type {
  ModuleAccessLevel,
  ModuleCatalogEntry,
  ModuleId,
  ModulePlane,
} from "./module-catalog.types.ts";

// RESOURCE_MODULE_CATALOG — groups AppPermissions into modules with read/write levels.
// admin.* uses per-module <module>.read / <module>.write permissions (T3).
export const RESOURCE_MODULE_CATALOG: Record<ModuleId, ModuleCatalogEntry> = {
  "admin.dashboard": {
    scope: "admin",
    resource: "dashboard",
    i18nKey: "modules.admin.dashboard",
    route: "/admin/dashboard",
    levels: {
      read: ["admin.dashboard.read"],
      write: ["admin.dashboard.read", "admin.dashboard.write"],
    },
    plane: "customer",
  },
  "admin.locations": {
    scope: "admin",
    resource: "locations",
    i18nKey: "modules.admin.locations",
    route: "/admin/locations",
    levels: {
      read: ["admin.locations.read"],
      write: ["admin.locations.read", "admin.locations.write"],
    },
    plane: "customer",
  },
  "admin.stations": {
    scope: "admin",
    resource: "stations",
    i18nKey: "modules.admin.stations",
    route: "/admin/stations",
    levels: {
      read: ["admin.stations.read"],
      write: ["admin.stations.read", "admin.stations.write"],
    },
    plane: "customer",
  },
  "admin.devices": {
    scope: "admin",
    resource: "devices",
    i18nKey: "modules.admin.devices",
    route: "/admin/devices",
    levels: {
      read: ["admin.devices.read"],
      write: ["admin.devices.read", "admin.devices.write"],
    },
    plane: "customer",
  },
  "admin.bikes": {
    scope: "admin",
    resource: "bikes",
    i18nKey: "modules.admin.bikes",
    route: "/admin/bikes",
    levels: {
      read: ["admin.bikes.read"],
      write: ["admin.bikes.read", "admin.bikes.write"],
    },
    plane: "customer",
  },
  "admin.bikeCatalog": {
    scope: "admin",
    resource: "bikeCatalog",
    i18nKey: "modules.admin.bikeCatalog",
    route: "/admin/bike-catalog",
    levels: {
      read: ["admin.bikeCatalog.read"],
      write: ["admin.bikeCatalog.read", "admin.bikeCatalog.write"],
    },
    plane: "customer",
  },
  "admin.materials": {
    scope: "admin",
    resource: "materials",
    i18nKey: "modules.admin.materials",
    route: "/admin/materials",
    levels: {
      read: ["admin.materials.read"],
      write: ["admin.materials.read", "admin.materials.write"],
    },
    plane: "customer",
  },
  "admin.users": {
    scope: "admin",
    resource: "users",
    i18nKey: "modules.admin.users",
    route: "/admin/users",
    levels: {
      read: ["admin.users.read"],
      write: ["admin.users.read", "admin.users.write"],
    },
    plane: "customer",
  },
  "admin.roles": {
    scope: "admin",
    resource: "roles",
    i18nKey: "modules.admin.roles",
    route: "/admin/roles",
    levels: {
      read: ["admin.roles.read"],
      write: ["admin.roles.read", "admin.roles.write"],
    },
    plane: "customer",
  },
  "admin.fsmWorkflows": {
    scope: "admin",
    resource: "fsmWorkflows",
    i18nKey: "modules.admin.fsmWorkflows",
    route: "/admin/fsm-workflows",
    levels: {
      read: ["admin.fsmWorkflows"],
      write: ["admin.fsmWorkflows"],
    },
    plane: "customer",
  },
  "admin.documentTypes": {
    scope: "admin",
    resource: "documentTypes",
    i18nKey: "modules.admin.documentTypes",
    route: "/admin/fsm-workflows/document-types",
    levels: {
      read: ["admin.documentTypes.read"],
      write: ["admin.documentTypes.read", "admin.documentTypes.write"],
    },
    plane: "customer",
  },
  "settings.customers": {
    scope: "settings",
    resource: "customers",
    i18nKey: "modules.settings.customers",
    route: "/settings/customers",
    levels: {
      read: ["settings.customers"],
      write: ["settings.customers"],
    },
    plane: "platform",
  },
  // Internal Belora tool, opt-in per customer via RoleForm (BEL-591); `ikos` grants it as Belora's own tenant.
  "reporting.kpiOps": {
    scope: "reporting",
    resource: "kpiOps",
    i18nKey: "modules.reporting.kpiOps",
    route: "/reporting/kpi-ops",
    levels: {
      read: ["reporting.kpiOps.read"],
      write: ["reporting.kpiOps.read", "reporting.kpiOps.write"],
    },
    plane: "customer",
  },
  "reporting.materialsBudget": {
    scope: "reporting",
    resource: "materialsBudget",
    i18nKey: "modules.reporting.materialsBudget",
    route: "/reporting/materials-budget",
    levels: {
      read: ["reporting.materialsBudget"],
      write: ["reporting.materialsBudget"],
    },
    plane: "customer",
  },
  requests: {
    scope: "requests",
    resource: "requests",
    i18nKey: "modules.requests",
    route: "/requests",
    levels: {
      read: ["requests.read"],
      write: ["requests.read", "requests.write"],
    },
    plane: "customer",
  },
  "portal.bikes": {
    scope: "portal",
    resource: "bikes",
    i18nKey: "modules.portal.bikes",
    route: "/portal/bikes",
    levels: { read: [], write: [] },
    plane: "customer",
  },
  "tracking.orderTracking": {
    scope: "tracking",
    resource: "orderTracking",
    i18nKey: "modules.tracking.orderTracking",
    route: "/tracking",
    levels: {
      read: ["tracking.orderTracking.read"],
      write: ["tracking.orderTracking.read"],
    },
    plane: "customer",
  },
};
